// extracted by mini-css-extract-plugin
export var growableInput = "_9c-0";
export var tagContainer = "_9c-2";
export var textInput = "_9c-1";